import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getEntityUrl } from '@culture/utils/helpers/entities';

import Thumbnail from 'components/Thumbnail';
import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const BookCard = ({ entity, colorIndex, keepRatio, cropText, type }) => {
	const getColorForBook = (index) => {
		const colors = [
			'azure',
			'darkChocolate',
			'grey',
			'purple',
			'lightChocolate',
			'blue'
		];
		if (index >= colors.length) {
			return colors[index - colors.length];
		}
		return colors[index];
	};

	const { authors = [], title } = entity;
	const url = getEntityUrl('books', entity);
	const author = authors[0];

	const cardCx = cx(
		styles.BookCard,
		styles[`BookCard_color_${getColorForBook(colorIndex)}`],
		keepRatio && styles.BookCard_keepRatio,
		cropText && styles.BookCard_cropText,
		type && styles[`BookCard_type_${type}`]
	);

	return (
		<NextLink className={cardCx} href={url}>
			<div className={styles.BookCard__Inner}>
				<div className={styles.BookCard__WrapThumbnail}>
					<Thumbnail
						className={styles.BookCard__Thumbnail}
						file={author?.thumbnailFile}
						placeholderType="persons"
						placeholderAlign="center"
						theme="circle"
					/>
				</div>
				<div className={styles.BookCard__Content}>
					<div className={styles.BookCard__Body}>
						<div className={styles.BookCard__Author}>{author?.title}</div>
						<div className={styles.BookCard__Title}>{title}</div>
					</div>
				</div>
			</div>
		</NextLink>
	);
};

BookCard.propTypes = {
	entity: PropTypes.shape({
		authors: PropTypes.array.isRequired,
		title: PropTypes.string.isRequired,
		thumbnailFile: PropTypes.object
	}).isRequired,
	colorIndex: PropTypes.number.isRequired,
	keepRatio: PropTypes.bool,
	cropText: PropTypes.bool,
	type: PropTypes.oneOf(['slide'])
};

export default BookCard;
